__turbopack_context__.v({
  "richTextContainer": "_-module__P5ftpG__richTextContainer",
});
